// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1Iaq0","sendOtp":"AuthorizeToLogin_sendOtp__1foih"};